export const QR_TYPES = {
  CONFIDENCE: 'confidence',
  COMPUTER_SCIENCE: 'computerScience',
};
